import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { contactInfo, faqs } from '../../data/home';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-118" data-mp="252toikhv9o29">
      <div className="grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-119" data-mp="1v6gm8y89a1vw">
        <div className="lg:col-span-4" data-id="element-120" data-mp="1v4x7xd65u0wr">
          <h2 id="faq-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[32px]" data-id="element-121" data-mp="205besrw0z4t7">
            Vragen die we vaak krijgen
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-122" data-mp="1m7d4pyoqluji">
            Staat je vraag er niet tussen? Bel{' '}
            <a href={contactInfo.phoneHref} className="font-semibold text-ink underline underline-offset-2" data-id="element-123" data-mp="1r6pyz4hxu3w4">
              {contactInfo.phone}
            </a>{' '}
            of mail naar{' '}
            <a href={`mailto:${contactInfo.email}`} className="font-semibold text-ink underline underline-offset-2" data-id="element-124" data-mp="3lgtkjkdlctk8">
              {contactInfo.email}
            </a>
            .
          </p>
        </div>

        <ul className="divide-y divide-line border-y border-line lg:col-span-8" data-id="element-125" data-mp="2jcj959grgzbv">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-126" data-mp="2s7frosmdfoce" data-mpi={i}>
                <h3 data-id="element-127" data-mp="24h3f34g6l3fh">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[15px] font-semibold text-ink hover:text-ink/80" data-id="element-128" data-mp="24gjwdlipib0e">
                    {f.q}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[background-color,transform] duration-200 ${isOpen ? 'rotate-45 bg-ink text-volt' : 'bg-surface text-ink'}`} aria-hidden="true" data-id="element-129" data-mp="3ptmx24qi1kpt">
                      <PlusIcon className="h-4 w-4" data-id="element-130" data-mp="u2zhnr933iz" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-131" data-mp="aqxx84fp8zw7">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-132" data-mp="3981w8rm1qsxj">
                      <p className="max-w-2xl pb-5 pr-12 text-sm leading-relaxed text-muted" data-id="element-133" data-mp="2qhk34lxaxvbn">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}